
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Grenoble dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Grenoble certifiée Google Partner, soutient les entreprises grenobloises pour développer leur visibilité en ligne et conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Grenoble dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Grenoble certifiée Google Partner, soutient les entreprises grenobloises pour développer leur visibilité en ligne et conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
